import React, { useState } from 'react';
import { AttributeColumnRenderer, TableStyle } from '@leverege/ui-attributes';
import { Dialog, Button, Flex, Text } from '@leverege/ui-elements';
import classnames from 'classnames';
import ImageLoader from "./ImageLoader.js";
import S from './Renderer.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class ImageColumnRenderer extends AttributeColumnRenderer {
  renderCell = data => {
    const {
      value,
      column: {
        attribute
      }
    } = data;
    const empty = this.column?.cell?.emptyValue;
    const emptyIcon = this.column?.cell?.emptyIcon;
    const buttonText = attribute.source.attribute.getString('viewImage', '');
    const titleText = attribute.source.attribute.getString('titleDialogImage', `View ${attribute.displayName}`);
    const {
      objectFit,
      imageHeight,
      imageWidth
    } = this.column?.dialog || {};
    const imageStyle = {
      objectFit,
      width: imageWidth && `${imageWidth}px`,
      height: imageHeight && `${imageHeight}px`
    };
    const buttonVariant = this.column?.cell?.variant;
    const titleIcon = this.column?.dialog?.titleIcon;
    const alignItems = TableStyle.toFlexAlign(this.column?.cell?.align || 'baseline');
    const justifyItems = TableStyle.toFlexJustify(this.column?.cell?.justify || 'initial');
    const [showDialog, setShowDialog] = useState(false);
    return value ? /*#__PURE__*/_jsxs("div", {
      style: {
        display: 'flex',
        alignItems,
        flexWrap: 'nowrap',
        justifyItems
      },
      children: [/*#__PURE__*/_jsx(Button, {
        variant: buttonVariant,
        onClick: () => setShowDialog(true),
        children: buttonText !== '' && buttonText
      }), /*#__PURE__*/_jsx(Dialog, {
        bodyVariant: "dialogBody",
        bodyClassName: classnames(S.noSize, S.win, S.really),
        title: /*#__PURE__*/_jsxs(Flex, {
          variant: "rowSpaceBetween",
          children: [/*#__PURE__*/_jsx(Text, {
            icon: titleIcon,
            variant: "dialogTitle",
            children: titleText
          }), /*#__PURE__*/_jsx(Button, {
            onClick: () => setShowDialog(false),
            variant: "closeDialog"
          })]
        }),
        show: showDialog,
        onClose: () => setShowDialog(false),
        children: /*#__PURE__*/_jsx(Flex, {
          align: "center",
          justify: "center",
          children: /*#__PURE__*/_jsx(ImageLoader, {
            value: value,
            valueStyle: imageStyle
          })
        })
      })]
    }) : /*#__PURE__*/_jsx(Text, {
      icon: emptyIcon,
      children: empty
    });
  };
}